/**
 * o-moti（挙動情報収集 / 認証成否通知）スクリプトの定義。
 *
 * このアプリは SPA のため public/index.html の <body> は全画面共通になる。
 * 画面ごとに出し分ける必要があるので、各画面コンポーネントから
 * useBodyScript で <body> 末尾へ動的に挿入する。
 */

export interface BodyScriptConfig {
  /** 読み込むスクリプトの src */
  src: string;
  /** script 要素へ付与する追加属性 */
  attributes: Record<string, string>;
}

const OMOTI_CFG =
  "eyJjb2xsZWN0b3JLZXkiOiI0YzVmNjNkYy1hZmQxLTRlYzUtYWI4ZC05MjljMWFhNzdlOWEiLCJldmVudElkIjoiMDEiLCJoYXNoIjp7ImVuYWJsZWQiOnRydWUsInNhbHQiOiI3Mzc0NDk5NCJ9fQ==";

/** 挙動情報収集スクリプト：ログイン画面に埋め込む */
export const OMOTI_COLLECTOR_SCRIPT: BodyScriptConfig = {
  src: "https://collector.o-moti.com/cdn/assets/js/sess73744994.js",
  attributes: {
    "data-omoti-cfg": OMOTI_CFG,
  },
};

/** 認証成否通知スクリプト：ログイン操作の成功直後に発火させる */
export const OMOTI_OV_SCRIPT: BodyScriptConfig = {
  src: "https://collector.o-moti.com/cdn/assets/js/sess73744994_ov.js",
  attributes: {
    "data-omoti-cfg": OMOTI_CFG,
  },
};
